import React, { Component } from 'react';
import { SubmissionError } from 'redux-form';
import { toast } from 'react-toastify';

import { simoMassRestore, quickMassRestore } from 'api';
import Spinner from 'components/Spinner';
import MassRestoreForm from 'components/MassActions/Subs/MassRestoreForm';

const carrierConfig = {
  simo: {
    massRestore: simoMassRestore,
  },
  quick: {
    massRestore: quickMassRestore,
  },
};
class MassRestore extends Component {
  state = {
    result: null,
    loading: false,
  };

  transformValues = (values) => {
    const carrier = this.props.carrier;
    let newValues = { ...values };
    if (carrier === 'simo') {
      newValues.device_sns = values.device_sns.replace(/ /g, '');
    } else if (carrier === 'quick') {
      newValues.sub_ids = values.sub_ids.replace(/ /g, '');
    }
    return newValues;
  };

  handleSubmit = (values) => {
    const { massRestore } = carrierConfig[this.props.carrier];
    this.setState({ loading: true });
    return massRestore(this.transformValues(values))
      .then((res) => {
        this.setState({ loading: false, result: res.data });
        toast.success('Requested mass restore successfully');
      })
      .catch((err) => {
        let messages = err.response
          ? err.response.data
          : { detail: 'Something went wrong' };
        this.setState({ loading: false, result: null });
        throw new SubmissionError(messages);
      });
  };

  render() {
    const { carrier } = this.props;
    const { loading } = this.state;
    let initialValues;
    if (carrier === 'simo') {
      initialValues = {
        device_sns: '',
      };
    } else if (carrier === 'quick') {
      initialValues = {
        sub_ids: '',
      };
    }

    return (
      <div className="mar-t-40">
        <h2>Mass Restore</h2>
        <div className="relative">
          <MassRestoreForm
            onSubmit={this.handleSubmit}
            initialValues={initialValues}
            carrier={carrier}
          />
          <Spinner showLoader={loading} />
        </div>
      </div>
    );
  }
}

export default MassRestore;
